import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { getBuilderAttributes } from "./builderAttributes";
import { FormContext } from "./CMSRenderer";
import { getDataFromAPI, getTranlation, getValue } from "./function";

export const TestimonialCard = ({
  bg = "#E4EFF3",
  icon = undefined,
  icon_type = "outlined",
  description = "Dubai the homeland pioneering in health, happiness and prosperity",
  icon_library, // material || fas
  builderAttributes = {},
}) => {
  return (
    <div
      {...builderAttributes}
      className="border-s-4 border-primary ps-5 pe-1 rounded-e-xl py-4 h-[80%] flex flex-col items-start"
      style={{ background: bg }}
    >
      {icon && icon_library === "material" ? (
        <span
          className={`text-primary text-4xl shrink-0 material-symbols-${
            icon_type && icon_type !== "" ? icon_type : ""
          }`}
        >
          {icon && icon !== "" && icon}
        </span>
      ) : (
        icon && { icon }
      )}
      {description && description !== "" && (
        <p className="text-black body my-2">{description}</p>
      )}
    </div>
  );
};

export const FileDownloadRow = ({
  fileIcon,
  fileName,
  downloadIcon,
  onDownload,
  fileSize,
  builderAttributes = {},
}) => (
  <div {...builderAttributes} className="flex justify-between items-center">
    <div className="flex items-center gap-4">
      <img src={fileIcon} alt="File Type Icon" />
      <div>
        <p className="body text-black">
          {fileName && fileName !== "" && fileName}
        </p>
        {fileSize && <p className="small">{fileSize}</p>}
      </div>
    </div>
    <img
      src={downloadIcon}
      alt="Download Icon"
      className="cursor-pointer"
      onClick={typeof onDownload === "string" ? eval(onDownload) : onDownload}
    />
  </div>
);

export const Tab = React.memo(({ config = {} }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [tabData, setTabData] = useState([]);
  const [tabItems, setTabItems] = useState([]);
  const { configuration, setConfiguration, tabType, currentLang } =
    useContext(FormContext);
  const tabsRef = useRef(null);
  useEffect(() => {
    const currentTabs = tabsRef.current;
    if (currentTabs) {
      const handler = (event) => {
        setConfiguration({
          ...configuration,
          [`${config?._id}_tabs`]: getTabData(),
          [config?._id]: getTabData()?.[event.detail],
          [config?.linker]: getTabData()?.[event.detail],
        });
      };
      currentTabs.addEventListener("tabClick", handler);
      return () => currentTabs.removeEventListener("tabClick", handler);
    }
  }, [tabItems, tabData]);

  useEffect(() => {
    if (!configuration?.[config?._id]) {
      setConfiguration({
        ...configuration,
        [`${config?._id}_tabs`]: getTabData(),
        [config?._id]: getTabData()?.[0],
        [config?.linker]: getTabData()?.[0],
      });
    }
  }, [tabItems, tabData]);

  useEffect(() => {
    if (config?.data_source && config?.data_source !== "") {
      getData();
    }
  }, []);

  useEffect(() => {
    setTabItems(getTabData());
  }, [tabData]);

  const getData = async () => {
    setIsLoading(true);
    getDataFromAPI({
      config: config,
      page: 1,
      pageSize: 10,
      setConfiguration,
      configuration,
    }).then((res) => {
      setTabData(res);
      setIsLoading(false);
    });
  };

  const getTabData = () => {
    if (config?.data_source && config?.data_source !== "") {
      const tabItems = config?.children?.flatMap((child) => {
        const item =
          currentLang === "en"
            ? child
            : { ...getTranlation({ config: child }) };

        if (!item?.title_params) return item?.title ? [item.title] : [];

        const params = JSON.parse(item.title_params);

        if (Array.isArray(tabData)) {
          return tabData.map((tab) =>
            getValue({
              type_identifier: { params },
              currentElement: tab,
            })
          );
        } else {
          return [
            getValue({
              type_identifier: { params },
              currentElement: tabData,
            }),
          ];
        }
      });
      return tabItems;
    } else {
      if (config?.children?.length > 0)
        return config?.children?.map((child) =>
          currentLang === "en"
            ? child?.title
            : getTranlation({ config: child })?.title
        );
      return "[]";
    }
  };

  const builderAttributes = getBuilderAttributes(config);

  if (isLoading) return <div {...builderAttributes}>Loading ...</div>;
  return (
    <dda-tabs
      ref={tabsRef}
      tab_type={
        config?.props?.tab_type && config?.props?.tab_type !== ""
          ? config?.props?.tab_type
          : tabType
      }
      {...config?.props}
      {...builderAttributes}
      // tab_texts={
      //   config?.children?.length > 0
      //     ? JSON.stringify(config?.children?.map((child) => child?.title))
      //     : "[]"
      // }
      tab_texts={JSON.stringify(tabItems)}
    ></dda-tabs>
  );
});

export const TabContent = ({
  config = {},
  index_identifier = 0,
  parent_index = 0,
  children,
}) => {
  const { configuration, setConfiguration } = useContext(FormContext);
  const dataList = configuration?.[`${parent_index}_data`];

  const isVisible =
    config?.title_params && config?.title_params !== ""
      ? Array.isArray(configuration?.[`${parent_index}_data`])
        ? configuration?.[`${parent_index}_data`]?.find(
            (i) =>
              getValue({
                type_identifier: {
                  params: JSON.parse(config?.title_params),
                },
                currentElement: i,
              }) === configuration?.[parent_index]
          )
        : getValue({
            type_identifier: {
              params: JSON.parse(config?.title_params),
            },
            currentElement: configuration?.[`${parent_index}_data`],
          }) === configuration?.[parent_index]
      : configuration?.[
          config?.linker && config?.linker !== ""
            ? config?.linker
            : parent_index
        ] === config?.title && config?.title !== ""
      ? config?.title
      : "";

  useEffect(() => {
    if (
      (!config?.title_params && config?.title_params !== "") ||
      (!config?.accessable_linker?.use && config?.accessable_linker?.use !== "")
    )
      return;

    const titleParams = JSON.parse(config.title_params);
    const accessableParams = JSON.parse(config.accessable_linker.use || "[]");

    let accessValue = "";
    if (Array.isArray(dataList)) {
      const matchedItem = dataList.find((i) => {
        const titleVal = getValue({
          type_identifier: { params: titleParams },
          currentElement: i,
        });

        return titleVal === configuration?.[parent_index];
      });

      if (matchedItem) {
        accessValue = getValue({
          type_identifier: { params: accessableParams },
          currentElement: matchedItem,
        });
      }
    } else {
      const titleVal = getValue({
        type_identifier: { params: titleParams },
        currentElement: dataList,
      });

      if (titleVal === configuration?.[parent_index]) {
        accessValue = getValue({
          type_identifier: { params: accessableParams },
          currentElement: dataList,
        });
      }
    }

    if (accessValue !== undefined) {
      setConfiguration((prev) => ({
        ...prev,
        [config.accessable_linker.name]: accessValue,
      }));
    }
  }, [dataList, isVisible]);

  return isVisible ? (
    <div {...getBuilderAttributes(config)}>{children}</div>
  ) : null;
};

export const TableItemsRenderer = React.memo(({ config, children }) => {
  const { configuration, setConfiguration } = useContext(FormContext);
  const [url, setUrl] = useState(
    config?.data_source && (config?.data_source !== "") & config?.data_source
  );
  const [hasFetched, setHasFetched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (config?.data_source && config?.data_source !== "") {
      const match = config?.data_source.match(/\[.*?\]/);
      if (match) {
        try {
          // 2. Parse it as a real array
          const paramsArray = JSON.parse(match[0]);

          // 3. Call your function to get the result
          const result = getValue({
            type_identifier: { params: paramsArray },
            currentElement: configuration,
          });

          // 4. Replace the array in the URL with the result
          const updatedUrl = config?.data_source.replace(match[0], result);
          console.log(updatedUrl, "checkurl1");
          if (!updatedUrl.includes("undefined")) {
            setUrl(updatedUrl);
            setHasFetched(true);
          }
        } catch (err) {
          console.error("Invalid array format in URL:", err);
        }
      }
    }
  }, [configuration]);

  useEffect(() => {
    if (!hasFetched || !url) return;
    setIsLoading(true);

    // ✅ Safe to fetch data now
    getDataFromAPI({
      config: {
        ...config,
        data_source: url,
      },
      setConfiguration,
      configuration,
      url,
    }).then((res) => {
      setIsLoading(false);
    });
  }, [url, hasFetched]);

  const builderAttributes = getBuilderAttributes(config);

  if (isLoading)
    return (
      <div
        {...builderAttributes}
        style={{
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Loading ....
      </div>
    );
  return (
    <table {...builderAttributes} className={config?.classname || ""}>
      {children}
    </table>
  );
});

export const PaginationRenderer = React.memo(
  ({
    totalPage = 1,
    currentPage = 1,
    handlePage,
    pageSize = 10,
    totalItems = 0,
    config = {},
    currentLang = "en"
  }) => {
    const builderAttributes = getBuilderAttributes(config);
    const allPages = Array.from({ length: totalPage }, (_, i) => i + 1); // [1..30]
    const totalPages = allPages.length;

    const groupSize = 3;
    const groupStart = Math.floor((currentPage - 1) / groupSize) * groupSize;
    const visiblePages = allPages.slice(groupStart, groupStart + groupSize);

    const showEllipsis = visiblePages.at(-1) < totalPages;
    return (
      <div {...builderAttributes} className="flex items-center justify-between">
        <div className="body">
          {currentLang == "en" ? "Showing" : "عرض"} {(currentPage - 1) * pageSize + 1} -{" "}
          {Math.min(currentPage * pageSize, totalItems)} {currentLang == "en" ? "of" : "من"} {totalItems} {currentLang == "en" ? "results" : "نتيجة"}
        </div>
        <div className="flex items-center text-[#454747] body gap-[10px] dha-pagination">
          <div
            className="w-[40px] h-[40px] flex items-center justify-center cursor-pointer arrow_back"
            onClick={() => handlePage(currentPage - 1)}
            style={{
              pointerEvents: 1 === currentPage ? "none" : "",
              opacity: 1 === currentPage ? "0.5" : "1",
              userSelect: "none",
            }}
          >
            <i
              className="material-icons material-symbols-outlined"
              aria-hidden="true"
            >
              arrow_back
            </i>
          </div>
          {visiblePages
            .filter((i) => i !== allPages.at(-1))
            .map((pagination) => (
              <div
                key={pagination}
                style={{
                  userSelect: "none",
                  color: pagination === currentPage ? "#006874" : "",
                }}
                className="Regular w-[40px] h-[40px] flex items-center justify-center cursor-pointer"
                onClick={() => handlePage(pagination)}
              >
                {pagination}
              </div>
            ))}

          {showEllipsis && (
            <div
              style={{ userSelect: "none" }}
              className="w-[40px] h-[40px] flex items-center justify-center cursor-pointer"
            >
              ...
            </div>
          )}
          <div
            onClick={() => handlePage(allPages.at(-1))}
            style={{
              userSelect: "none",
              color: allPages.at(-1) === currentPage ? "#006874" : "",
            }}
            className="w-[40px] h-[40px] flex items-center justify-center cursor-pointer"
          >
            {allPages.at(-1)}
          </div>
          <div
            className="w-[40px] h-[40px] flex items-center justify-center cursor-pointer arrow_forward"
            onClick={() => handlePage(currentPage + 1)}
            style={{
              userSelect: "none",
              pointerEvents: allPages.at(-1) === currentPage ? "none" : "",
              opacity: allPages.at(-1) === currentPage ? "0.5" : "1",
            }}
          >
            <i
              className="material-icons material-symbols-outlined"
              aria-hidden="true"
            >
              arrow_forward
            </i>
          </div>
        </div>
      </div>
    );
  }
);

export const DDABreadCrumbs = React.memo(({ config, breadCrumb, children }) => {
  const { configuration } = useContext(FormContext);

  const breadcrumbData = useMemo(() => {
    const linkerItem = breadCrumb?.find((i) => i?.useLinker === true);
    console.log(linkerItem, "check");

    if (linkerItem) {
      const staticItems =
        breadCrumb?.filter((i) => i?.useLinker !== true) || [];
      return [
        ...staticItems,
        {
          ...linkerItem,
          text: configuration?.[linkerItem?.text],
        },
      ];
    }
    console.log("calleds", breadCrumb);
    return breadCrumb;
  }, [configuration, breadCrumb]);

  return (
    <dda-breadcrumb
      key={JSON.stringify(breadcrumbData)}
      {...config?.props}
      design={config?.props?.design || "text"}
      separator="chevron_right"
      custom_class=""
      component_mode=""
      data-breadcrumbs={JSON.stringify(breadcrumbData)}
      {...getBuilderAttributes(config)}
    >
      {children}
    </dda-breadcrumb>
  );
});

export const DDAHeader = React.memo(({ config }) => {
  const headerRef = useRef(null);

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  useEffect(() => {
    const ddaHeader = headerRef.current;

    if (!ddaHeader) return;

    const handleLanguageSwitch = (event) => {
      const currentLang = getCookie("LangPref") || "ar";
      const newLang = currentLang === "en" ? "ar" : "en";
      const currentPath = window.location.pathname;
      const remainingPath = currentPath.replace(/^\/(en|ar)/, "");

      window.location.pathname = `/${newLang}${remainingPath}`;
    };

    ddaHeader.addEventListener("languageSwitch", handleLanguageSwitch);

    // Cleanup on unmount
    return () => {
      ddaHeader.removeEventListener("languageSwitch", handleLanguageSwitch);
    };
  }, []);

  return (
    <dda-header
      ref={headerRef}
      {...config?.props}
      {...getBuilderAttributes(config)}
    ></dda-header>
  );
});

export const TeamMemberCard = React.memo(
  ({
    image,
    name,
    title,
    description,
    links = [],
    showLinks = true,
    builderAttributes = {},
  }) => {
    return (
      <div
        {...builderAttributes}
        className="sm:flex items-center rounded-2xl gap-8"
      >
        <img
          src={image}
          alt={name}
          className="sm:w-56 sm:h-64 object-cover rounded-xl"
        />
        <div className="flex-1">
          <h5 className="mb-1">{name}</h5>
          <p className="text-primary body block mb-2">{title?.text || ""}</p>
          <p className="text-onSurfaceVariant body mb-4">{description}</p>
          {showLinks && (
            <div className="flex md:gap-4 gap-2">
              {links.map((link, idx) => (
                <a
                  key={idx}
                  href={link.url}
                  aria-label={link.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.icon &&
                  link?.icon !== "" &&
                  link.icon_library === "material" ? (
                    <span
                      className={`text-primary text-4xl shrink-0 material-symbols-${link.type}`}
                    >
                      {link.icon}
                    </span>
                  ) : typeof link?.icon === "string" ? (
                    // link?.icon
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          link?.icon && link?.icon !== "" ? link?.icon : "",
                      }}
                    />
                  ) : (
                    link?.icon
                  )}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
);

export const ImageCard = React.memo(
  ({
    imgSrc,
    imgAlt,
    title,
    description,
    linkTo,
    linkButtonText,
    builderAttributes = {},
  }) => {
    return (
      <div {...builderAttributes} className="rounded-2xl border border-outline">
        <img
          className="h-32 w-full object-cover rounded-t-2xl"
          src={imgSrc}
          alt={imgAlt}
        />
        <div className="p-4">
          <h6 className="Medium">{title}</h6>
          <p className="body text-onSurfaceVariant my-3">{description}</p>
          <a className="body text-primary" href={linkTo}>
            {linkButtonText ? linkButtonText : ""}
          </a>
        </div>
      </div>
    );
  }
);

export const EventVariantCard = React.memo(
  ({
    image,
    date = { month: "Oct", day: "26" },
    title = "World-class Quality",
    description = "The Dubai Health Authority is committed to always maintaining a leading position in global healthcare,...",
    link = "#",
    builderAttributes = {},
  }) => {
    const { currentLang } = useContext(FormContext);
    return (
      <a
        {...builderAttributes}
        href={`${link || "#"}`}
        className=" rounded-2xl shadow-sm border border-outline overflow-hidden flex h-full flex-col"
      >
        <div className="relative">
          <img src={image} alt={title} className="w-full h-40 object-cover" />
          <div className="absolute top-3 left-3 bg-white rounded-md px-3 py-1 shadow text-center">
            <p className="caption text-onSurfaceVariant">{date.month}</p>
            <h4 className="leading-none">{date.day}</h4>
          </div>
        </div>
        <div className="p-5 pb-4">
          <h5 className="mb-1">{title}</h5>
          <p className="text-onSurfaceVariant body mb-2">{description}</p>
        </div>
        <div className="border-t px-5 pb-3 pt-4 mt-auto">
          <a href={link} className="text-primary caption hover:underline">
            {currentLang == "en" ? "Read More" : "اقرأ المزيد"}
          </a>
        </div>
      </a>
    );
  }
);
